export default __webpack_public_path__ + "static/media/custom-full-view.ae57d4e9.svg";